import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Tooltip } from 'react-tooltip';

import { Encumbrance } from 'types';
import { getEncumbranceLabel } from '../utils/getEncumbranceLabel';

type EncumbrancesTooltipProps = {
  shareId: string;
  encumbrances: Encumbrance[];
};

const EncumbrancesTooltip: FC<EncumbrancesTooltipProps> = ({
  shareId,
  encumbrances,
}) => {
  const { t } = useTranslate();

  if (!encumbrances || encumbrances.length === 0) {
    return <>-</>;
  }

  return (
    <div
      data-tooltip-id={`encumbrance-info-${shareId}`}
      className="d-inline-block"
    >
      <em className="icon ni ni-info text-gray" />
      <Tooltip
        id={`encumbrance-info-${shareId}`}
        place="top"
        style={{ zIndex: 9999 }}
        render={() => (
          <div className="fw-normal">
            {t('EncumbrancesInfo')}
            <ul className="list text-left mb-0 pb-0">
              {encumbrances.map((encumbrance, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={`encumbrance-${index}`} className="mb-0 pb-0">
                  {t(getEncumbranceLabel(encumbrance))}
                </li>
              ))}
            </ul>
          </div>
        )}
      />
    </div>
  );
};

export default EncumbrancesTooltip;
